(function ($) {
    var $body = $('body');

    (function($) {
        $.fn.removeClassWild = function(mask) {
            return this.removeClass(function(index, cls) {
                var re = mask.replace(/\*/g, '\\S+');
                return (cls.match(new RegExp('\\b' + re + '', 'g')) || []).join(' ');
            });
        };
    })(jQuery);

    /* Scroll button */
    $body.on('click', '[data-scroll-to]', function (e) {
        e.preventDefault();

        var $this = $(this),
            dataScroll = $this.attr('data-scroll-to'),
            $offsetElement = $($this.attr('data-offset-element')),
            $section,
            offsetTop = 0,
            duration = $this.attr('data-duration') || env.scrollToDefault;

        if ($this.attr('data-scroll-to') == '_windowHeight'){
            $section = 'window';
            offsetTop = $(window).outerHeight();
        } else {
            var $section = $($this.attr('data-scroll-to'));
            offsetTop = $section.offset().top;
        }

        if($section == 'window' || $section.length > 0) {
            var scrollPosition = offsetTop;
            if ($offsetElement.length > 0){
                scrollPosition = scrollPosition - $offsetElement.outerHeight();
            }

            $('html, body').animate({
                scrollTop: scrollPosition
            }, parseInt(duration));
        } else {
            console.error('Section "' + $this.attr('data-scroll-to') + '" is not defined!');
        }
    });

    /* Toggle */
    $('body').on('click', '[data-toggle]', function (e) {
        e.preventDefault();
        var $this = $(this),
            $section = $($this.attr('data-toggle')),
            options = $.extend({}, env.default_toggle_options, jQuery.parseJSON($this.closest('[data-toggle-options]').attr('data-toggle-options')));

        if (typeof $section != "undefined"){
            if ($this.is('.toggle')){
                $this.removeClass('toggle');
                $section.removeClass('toggle');
                switch (options.type){
                    case "toggle":
                        $section.hide();
                        break;
                    case "slide":
                        $section.slideUp(options.duration);
                        break;
                    case "fade":
                        $section.fadeOut(options.duration);
                        break;
                }
            } else {
                $this.addClass('toggle');
                $section.addClass('toggle');
                switch (options.type) {
                    case "toggle":
                        $section.show();
                        break;
                    case "slide":
                        $section.slideDown(options.duration);
                        break;
                    case "fade":
                        $section.fadeIn(options.duration);
                        break;
                }
            }
        } else {
            console.warn('Toggle: parameter "data-toggle-section" is undefined');
        }
    });

    $body.on('change', '[data-select-all]', function () {
        var $this = $(this),
            $items = $($this.attr('data-select-all'));

        if($items.length > 0){
            if($this.is(':checked')){
                $items.prop('checked', true);
            } else {
                $items.prop('checked', false);
            }
        }
    })

})(jQuery);

/* Add preloader for button */
function buttonAddPreloader($button) {
    $button.addClass('btn-preloader');
    $button.append(env.ajaxPreloader);
}

/* Remove preloader from button */
function buttonRemovePreloader($button) {
    $button.removeClass('btn-preloader');
    $button.find('.loader').remove();
}

/* Step by step function */
function stepByStep(el, time, classToEl, step, inView, offset){
    var size = el.size(),
        newTime = (time == 'data-timeout' ? parseInt(el.eq(step).attr('data-timeout')) : time),
        newClassToEl = (classToEl == 'data-animation-class' ? el.eq(step).attr('data-animation-class') : classToEl),
        inProgress = false;

    if(step < size){
        function set() {
            el.eq(step).addClass(newClassToEl);
            setTimeout(function(){
                stepByStep(el, time, classToEl, ++step, inView, offset);
            }, newTime);
        }
        if(inView){
            function check() {
                if(jQuery(window).scrollTop() + jQuery(window).outerHeight() >= el.eq(step).offset().top + offset){
                    set();
                    inProgress = true;
                } else {
                    inProgress = false;
                }
            }
            check();
            jQuery(window).on('scroll', function () {
                if(!inProgress){
                    check();
                }
            });
        } else {
            set();
        }
    }
}

/* if high density */
function isHighDensity(){
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
}

/* if retina */
function isRetina(){
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

/* if integer */
function isInt(value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
}

/* if element into view */
function isScrolledIntoView(elem, offset){
    var docViewTop = jQuery(window).scrollTop();
    var docViewBottom = docViewTop + jQuery(window).height();

    var elemTop = jQuery(elem).offset().top + offset;
    var elemBottom = elemTop + jQuery(elem).height() - offset;

    return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

/* if iphone */
function isiPhone(){
    return (
        (navigator.platform.indexOf("iPhone") != -1) ||
        (navigator.platform.indexOf("iPod") != -1) ||
        (navigator.platform.indexOf("iPad") != -1)
    );
}

/**
 * @returns {bool}
 */
function isMobile() {
    return isDevice('ios') || isDevice('ipad') || isDevice('iphone') || isDevice('ipod') || isDevice('android') || isDevice('blackberry') || isDevice('windows_phone');
}

function isDevice(device) {
    var result;
    switch (device){
        case 'ios': result = /ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase()); break;
        case 'ipad': result = /ipad/i.test(navigator.userAgent.toLowerCase()); break;
        case 'iphone': result = /iphone/i.test(navigator.userAgent.toLowerCase()); break;
        case 'ipod': result = /ipod/i.test(navigator.userAgent.toLowerCase()); break;
        case 'android': result = /android/i.test(navigator.userAgent.toLowerCase()); break;
        case 'blackberry': result = /blackberry/i.test(navigator.userAgent.toLowerCase()); break;
        case 'windows_phone': result = /windows phone/i.test(navigator.userAgent.toLowerCase()); break;
        case 'pc': result = /windows/i.test(navigator.userAgent.toLowerCase()); break;
    }

    return result;
}

function is_touch_device() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function getUrlID(n){
    var path = window.location.pathname.split("/");
    return path[n]
}